<section class="title-section">
    <span class="page-title">{{title}}</span>
</section>